<h2>Android download</h2>

          <form [formGroup]="profileForm" class="form" (ngSubmit)="downloadAndroidPumpSystems()">
            <ng-template matStepLabel>System components</ng-template>

            <div class="form-element">
              <button mat-raised-button color="primary" type="submit">Download android file</button>
            </div>
          </form>

          <form [formGroup]="profileForm" class="form" (ngSubmit)="downloadAndroidSystemsExcel()">
            <ng-template matStepLabel>System components</ng-template>

            <div class="form-element">
              <button mat-raised-button color="primary" type="submit">Download android EXCEL file</button>
            </div>
          </form>
